<template>
  <div id="btn-teams" :class="{ hidden: (!childrenCompany && isMobile), dark: darkRoute, }">
    <el-popover
      v-if="canSwitch"
      id="button-team"
      width="auto"
      popper-class="button-team-popover"
      placement="bottom"
      :trigger="isMobile ? 'click' : 'hover'"
      @after-leave="onLeave"
      @after-enter="isActive"
    >
      <template #reference>
        <div class="btn-teams">
          <div class="btn-team" :class="{ inactive: !childrenActive }">
            <div
              class="nb"
              :style="{ 'background-image': `url(${childrenActive ? logoChildrenCompany : logoParentCompany})` }"
            />
            <div v-if="selectedCompanyName" class="text hidden-xs">
              <MiddleEllipsis class="team-name" :text="selectedCompanyName" /> <el-icon class="el-icon-arrow-down" :class="{ active: menuDeploy }"><arrow-down /></el-icon>
            </div>
          </div>
        </div>
      </template>
      <div class="team-content children" :class="{ companies: accountStore.companies.length > 1 }">
        <ChooseTeamCard
          ref="chooseTeamCard"
          :show-all-teams="true"
          :is-header="true"
          :counter="teamCounter"
          @selected-company="selectCompany"
          @selected-account="selectAccount"
        />
      </div>
    </el-popover>
    <div v-else class="btn-teams">
      <div class="btn-team" :class="{ inactive: !childrenActive }">
        <div
          class="nb"
          :style="{ 'background-image': `url(${childrenActive ? logoChildrenCompany : logoParentCompany})` }"
        />
        <div v-if="selectedCompanyName" class="text hidden-xs">
          <MiddleEllipsis class="team-name" :text="selectedCompanyName" />
        </div>
      </div>
    </div>
    <div id="button-team-modal" :class="{ open: modalVisible }">
      <div class="modal">
        <div class="close" @click="closeModal()">
          <img src="/static/img/icones/icon-quit-template.svg" alt="close">
        </div>
        <p class="title">Changer de compte</p>
        <p>Vous vous apprétez à changer de compte pour passer commande, bien vu, il était temps ! 🙈</p>
        <p>Avant de switcher, sachez que toutes les informations renseignées seront malheuresement perdues.</p>
        <div class="btns">
          <button class="green" @click="confirmSwitchAccount">Switcher de compte</button>
          <button @click="closeModal">Rester sur ce compte</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useAccountStore } from '@/stores/account';
import { useAuthStore } from '@/stores/auth';
import { useCheckoutV2Store } from '@/stores/checkoutv2';
import { useCompanyStore } from '@/stores/company';
import accountService from '@/services/account';
import ChooseTeamCard from './ChooseTeamCard';
import MiddleEllipsis from './MiddleEllipsis';

export default {
  components: { ChooseTeamCard, MiddleEllipsis },
  props: [],
  data() {
    return {
      menuDeploy: false,
      selectedCompany: null,
      selectedAccount: null,
      modalVisible: false,
      isMobile: /Mobi/i.test(window.navigator.userAgent),
    };
  },
  computed: {
    ...mapStores(useAccountStore, useAuthStore, useCompanyStore),
    fromUserAgent() {
      if (this.authStore.userAgent.androidWebview || this.authStore.userAgent.iosWebview) {
        return 'app';
      }

      if (/Mobi/i.test(window.navigator.userAgent)) {
        return 'mobile';
      }
      return 'desktop';
    },
    darkRoute() {
      return (this.$route.name.includes('co.v2') && !this.$route.name.includes('template') && !this.$route.name.includes('co.v2.chooseteam'));
    },
    childrenCompany() {
      if (this.accountStore.company) {
        return this.accountStore.company.children;
      }
      return false;
    },
    teamCounter() {
      if (this.$route.name === 'validations.index') {
        return 'nbStudentsToValidate';
      }
      return this.$route.name === 'students.index' ? 'nbStudentsToRate' : '';
    },
    canSwitch() {
      return this.accountStore.companies.length > 1
        || this.customerEditOthers
        || (this.childrenCompany && Object.keys(this.childrenCompany).length > 0 && (this.customerOrderPlace || this.customerOrderRequest));
    },
    isCheckoutRoute() {
      return ['co.v2.create', 'co.v2.place', 'co.v2.summary'].includes(this.$route.name);
    },
    selectedCompanyName() {
      return this.companyStore.nameCompany;
    },
    childrenActive() {
      return this.companyStore.childrenActive;
    },
    logoParentCompany() {
      if (this.companyStore.parentCompany && this.companyStore.parentCompany.logo && this.companyStore.parentCompany.logo.format) {
        return this.companyStore.parentCompany.logo.format.small;
      }
      return this.companyStore.parentCompany ? this.companyStore.parentCompany.logo : '';
    },
    logoChildrenCompany() {
      if (this.companyStore.childrenCompany && this.companyStore.childrenCompany.logo) {
        return this.companyStore.childrenCompany.logo.format.small;
      }
      return false;
    },
    customerOrderPlace() {
      if (this.accountStore.permissions) {
        return this.accountStore.permissions.customerOrdersPlace;
      }
      return false;
    },
    customerEditOthers() {
      if (this.accountStore.permissions) {
        return this.accountStore.permissions.customerUserEditOthers;
      }
      return false;
    },
    customerOrderRequest() {
      if (this.accountStore.permissions) {
        return this.accountStore.permissions.customerOrdersRequest;
      }
      return false;
    },
  },
  methods: {
    isActive() {
      this.menuDeploy = !this.menuDeploy;
    },
    onLeave() {
      this.isActive();
      this.$refs.chooseTeamCard.resetPreview();
    },
    hidePopover() {
      const teamPopover = document.getElementsByClassName('button-team-popover');
      if (teamPopover && teamPopover[0]) {
        teamPopover[0].style.display = 'none';
      }
    },
    selectCompany(company) {
      this.hidePopover();

      if (this.isCheckoutRoute) {
        this.selectedCompany = company;
        this.modalVisible = true;
        return;
      }
      this.$mixpanel.track('Team Switched', { FromUseragent: this.fromUserAgent });
      let companyId = 'all';
      if (company === 'all') {
        this.companyStore.reset();
        companyId = 'all';
      } else {
        companyId = company.id;
        this.companyStore.change(company);
      }

      if (this.$route.name === 'co.v2.chooseteam') {
        this.$router.push({ path: '/template', query: { company: companyId } });
      } else {
        this.$router.replace({ query: { company: companyId, tab: this.$route.query.tab } });
      }
    },
    selectAccount(company) {
      this.hidePopover();
      if (this.isCheckoutRoute) {
        this.selectedAccount = company;
        this.modalVisible = true;
        return;
      }
      this.switchAccount(company);
    },
    // SP-14892 — `/me` is reloaded for the other company, then the missions list replaces
    // the current page, which may show data of the company we leave.
    switchAccount(company) {
      this.$mixpanel.track('Team Switched', { FromUseragent: this.fromUserAgent });
      this.closeModal();
      this.companyStore.rememberAccount(company.id);
      accountService.find(null, () => {
        useCheckoutV2Store().$reset();
        this.$router.push({ path: '/job', query: { company: company.id } });
      });
    },
    confirmSwitchAccount() {
      if (this.selectedAccount) {
        this.switchAccount(this.selectedAccount);
        return;
      }

      if (this.selectedCompany === 'all') {
        this.$mixpanel.track('Team Switched', { FromUseragent: this.fromUserAgent });
        this.companyStore.reset();
        this.$router.replace({ path: '/template' });
      } else {
        this.$mixpanel.track('Team Switched', { FromUseragent: this.fromUserAgent });
        this.companyStore.change(this.selectedCompany);
        this.$router.replace({ path: '/template', query: { company: this.selectedCompany.id } });
      }
      this.closeModal();
    },
    closeModal() {
      this.modalVisible = false;
      this.selectedAccount = null;
    },
  },
};
</script>
